import { c as _c } from "react/compiler-runtime";
import styles from '@/app/cv/components/sections/products/index.module.css';
import { ProductBadge } from '@/app/cv/components/sections/products/shared/badge';
import type { ProductBadgeProps } from '@/app/cv/components/sections/products/types';
import { cn } from '@/app/utils/cn';
export interface MixerItemProps {
  title: string;
  description?: string;
  badge?: ProductBadgeProps;
}
export const MixerItem = t0 => {
  const $ = _c(13);
  const {
    title,
    description,
    badge
  } = t0;
  const hasBadge = !!badge?.label;
  let t1;
  if ($[0] !== badge || $[1] !== hasBadge) {
    t1 = !!hasBadge && <ProductBadge {...badge} theme="dark" />;
    $[0] = badge;
    $[1] = hasBadge;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== title) {
    t2 = <h3 className="text-body-1 font-noto-bold text-white" dangerouslySetInnerHTML={{
      __html: title
    }} />;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== description) {
    t3 = !!description && <div className={cn("text-body-2 text-white", styles.mixerDescription)} dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="where-span:text-inline-wrap grid gap-y-2">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="grid items-start gap-y-4">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};